import { Trans } from "../utils/i18n";
import { isArray } from "lodash";
import { Inertia } from "@inertiajs/inertia";

export const hasProducts = (products) => {
    // In the case of array fields (e. g. in SelfRepairProductSelect or SelfRepairCheckout)
    // products is not an object like ({ [id]: [amount] }) but an array of products like [{id, amount}, ...]
    if (isArray(products)) {
        return (
            products.filter((item) => item && Number(item.amount ?? 0) > 0)
                .length > 0
        );
    }

    return (
        products &&
        Object.values(products).filter((item) => item && item !== "0").length >
            0
    );
};

export const selfRepairGuideConfig = {
    sizes: {
        forth: 3,
        third: 4,
        half: 6,
        full: 12,
    },
    enableStepper: true,
    heading: <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    groups: [
        {
            heading: (
                <Trans i18nKey="orderEntry.repairModality">
                    Repair Modality
                </Trans>
            ),
            description: (
                <Trans i18nKey="orderEntry.upload-documents.description">
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua.
                </Trans>
            ),
            id: "repairModality",
            fields: [
                ({ pageProps }) => ({
                    size: "full",
                    component: "selfrepairproductselect",
                    maxQuantity: pageProps?.maxQuantity ?? 10,
                }),
            ],
        },
    ],
    actions: [
        {
            fields: [
                {
                    text: <Trans i18nKey="shoppingCart.goToCheckout">Complete Checkout</Trans>,
                    size: "half",
                    component: "button",
                    onClick: () => {
                        Inertia.visit(route('partsshop.checkout'));
                    },
                    color: "secondary",
                    conditionFunction: (values, orderEntryState) => {
                        return hasProducts(values.products);
                    },
                },
            ],
        },
    ],
};
